import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
const bodyStyles = css `
  ${theme.typeStyles.bodyMediumStyles}
  overflow: auto;
  flex-grow: 1;
  padding-bottom: ${theme.spacing.x6};
  padding-left: ${theme.spacing.x6};
  padding-right: ${theme.spacing.x6};
  padding-top: ${theme.spacing.x6};
  ${'' /* If the body is the first element inside of the modal AND there is a close button present,
create a scroll header for the close button to keep it from colliding with the content of the modal */}

  &:not(:first-child):first-of-type {
    box-shadow: inset 0 ${styleUtils.rem(1)} 0 0 ${theme.colors.gray300};
    margin-top: ${theme.spacing.x8};
    padding-bottom: ${theme.spacing.x6};
    padding-left: ${theme.spacing.x6};
    padding-right: ${theme.spacing.x6};
    padding-top: ${theme.spacing.base};
    position: relative;
    z-index: 0;

    &::before {
      content: '';
      height: ${styleUtils.rem(1)};
      left: 0;
      outline: ${styleUtils.rem(1)} solid ${theme.colors.gray100};
      position: absolute;
      top: -${styleUtils.rem(1)};
      width: 100%;
      z-index: 1;
    }
  }
`;
const ModalBody = ({ children, }) => (_jsx("div", Object.assign({ css: bodyStyles }, { children: children })));
const MemoizedModalBody = memo(ModalBody);
export { MemoizedModalBody as ModalBody };
// MC-1068 Temporary hack for Storybook.
export default ModalBody;
